// Core
import { useState } from 'react';
import { Box, Flex, Text, Image, Button } from '@chakra-ui/react';
import { useSpring, animated } from '@react-spring/web';
import { useDrag } from '@use-gesture/react';
import { RiMessage3Fill, RiProfileFill } from 'react-icons/ri';
import { FaHeart, FaUser } from 'react-icons/fa';
import { IoLocationSharp, IoCloseOutline } from 'react-icons/io5';
import { IoIosClose } from 'react-icons/io';
import { MdCancel } from 'react-icons/md';
import { MdFilterList } from 'react-icons/md';
import { useHistory, Link } from 'react-router-dom';
import { FaPlus } from 'react-icons/fa6';
import { IoIosSettings } from 'react-icons/io';

// Components
import { textLang } from 'services/Lang';
import Approved from './components/Approved';
import Match from './components/Match';
import MatchInfo from './components/MatchInfo';
import { groupsLikeMe } from '../../variables/data';

const MatchGroup = ({object, countNewUserInMyGroups}) => {
  const [active, setActive] = useState(0);
  const [showInfo, setShowInfo] = useState(0);
  const [showInfoType, setShowInfoType] = useState('match');
  const [isAnimateNext, setIsAnimateNext] = useState(false);
  const [item, setItem] = useState({});

  const colorMatch = 'white';

  return (
    <Box p="130px 15px 24px 15px" maxH="calc(100vh - 0px)" pb="130px" overflowY="auto" position="relative">
      <Box 
        position="absolute"
        transform="translate(-50%, 0px)"
        left="50%"
        overflow="visible"
        my="-72px"> 
        <Link to="/group-profile" style={{width: '140px', position: 'relative'}}>
          <Button variant="button-sm" w="180px" leftIcon={<IoIosSettings fontSize="21px" />}>
            {textLang('my_groups')}
          </Button>
          { countNewUserInMyGroups > 0 && (
            <Box
              position="absolute"
              top="-14px"
              right="-6px"
              width="24px"
              height="24px"
              bg="#ffffff"
              borderRadius="full"
              border="0.5px solid #fe4033"
              color="#fe4033"
              fontWeight="600"
              fontSize="12px"
              display="flex"
              alignItems="center"
              justifyContent="center"
              lineHeight="1"
            >
              {countNewUserInMyGroups > 9 ? '9+' : countNewUserInMyGroups}
            </Box>
          )}
        </Link>
      </Box>

      {/*<Flex mb="24px" alingItems="center" gap="8px">
        <MdFilterList fontSize="21px" />
        <Text variant="title-md" mt="1px">FILTERS</Text>
      </Flex>*/}

      <Match 
        object={object}
        active={active} setActive={setActive} setShowInfo={setShowInfo} setShowInfoType={setShowInfoType} setItem={setItem} />

      <Approved active={active} setActive={setActive} setShowInfo={setShowInfo} setShowInfoType={setShowInfoType} setItem={setItem} />

      <Box className="match-user-info" h={ showInfo ? '50%' : '0' }>
        <Box onClick={() => setShowInfo(false)} top="20px" right="10px" position="absolute">
          <IoIosClose fontSize="70px" />
        </Box>
        <MatchInfo item={item} type={showInfoType} />
      </Box>

      {/*<Box
        position="fixed"
        top="0"
        p="0 20px"
        left="0"
        w="100%"
        h="100%"
        zIndex="0"
        bg="#ffffff91"
        backdropFilter="blur(7px)"
        textAlign="center"
        overflow="hidden"
        display="flex"
        flexDirection="column"
        justifyContent="center" 
        alignItems="center"
      >
        <Text variant="title-lg" fontSize="32px" fontWeight="900">{textLang('coming_soon')}</Text>
        <Text variant="title-lg">{textLang('group_coming_soon_text')}</Text>
      </Box>*/}
    </Box>
  );
};

export default MatchGroup;
